module.exports = {
  systems: {
    IU: {
      label: 'Imperial',
      key: 'IU'
    },
    SI: {
      label: 'Metric',
      key: 'SI',
    },
  },
  IU: {
    wt: {
      label: 'lb',
      key: 'lb',
    },
    ft: {
      label: 'ft',
      key: 'ft',
    },
    in: {
      label: 'in',
      key: 'in',
    },
  },
  SI: {
    wt: {
      label: 'kg',
      key: 'kg',
    },
    ht: {
      label: 'cm',
      key: 'cm',
    },
  }
};